const NAME = 'SENDBIRD';

export const isSbConnected = (store) => store[NAME].connect.isConnected;
